<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <PagePicker v-model="value.page" title="Page" />
      </v-col>
      <v-col cols="12">
        <v-text-field
          hide-details
          v-model="value.route"
          label="Or Route"
          filled
        ></v-text-field>
      </v-col>
      <v-col>
        <v-checkbox
          hide-details
          label="Replace Current Route"
          v-model="value.replace"
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <FieldValuePickerBase
          title="Page Parameter"
          :table="table"
          :component="component"
          :containers="containers"
          v-model="value.parameterName"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FieldValuePickerBase from "../shared/FieldValuePickerBase.vue";
import PagePicker from "../shared/PagePicker.vue";

export default {
  name: "GoPageDesigner",

  components: { PagePicker, FieldValuePickerBase },

  props: ["value", "table", "component", "containers"],
};
</script>
